import React from 'react';
import Teaser from 'components/FullTeaser/FullTeaser';
import { useSession } from 'next-auth/react';
import useFavoriteCmsItems from 'hooks/useFavoriteCmsItems';
import IconClose from 'components/Icons/IconClose';
import Loading from 'components/Loading/Loading';
import ForYouInner from '../ForYouInner';
import { getServerSession } from 'next-auth';
import { authOptions } from 'pages/api/auth/[...nextauth]';
import type { GetServerSideProps } from 'next';

const ForYou = () => {
  const sessionData = useSession();
  const session = sessionData.data;

  const {
    favorites: favoriteStories,
    deleteFavorite: deleteStoryFavorite,
    isLoading: isLoadingStories,
  } = useFavoriteCmsItems('story');

  const {
    favorites: favoriteEpisodes,
    deleteFavorite: deleteEpisodeFavorite,
    isLoading: isLoadingEpisodes,
  } = useFavoriteCmsItems('episode');

  const deleteTile = (favorite: { id: string; resourceType: string }) => {
    switch (favorite.resourceType) {
      case 'story':
        deleteStoryFavorite(favorite.id);
        break;
      case 'episode':
        deleteEpisodeFavorite(favorite.id);
        break;
    }
  };

  const isLoggedIn = Boolean(session?.user);

  if (!isLoggedIn) {
    return (
      <ForYouInner
        current="stories"
        inner={<div>Please log in to view your favorites.</div>}
      />
    );
  }
  if (isLoadingEpisodes && isLoadingStories) {
    return <ForYouInner current="stories" inner={<Loading />} />;
  }

  const Jsx = (
    <div className="for-you">
      <div className="container">
        <main>
          <div id="mainContent"></div>
          <div className="for-you-welcome">
            <h2>
              Welcome back{' '}
              {session?.user.given_name || session?.user.username || ''}
            </h2>
          </div>
          <h3>Stories</h3>
          <div className="collection">
            {favoriteStories.length > 0 ? (
              <div>
                {favoriteStories.map((item) => (
                  <div className="for-you-item" key={item.id}>
                    <Teaser
                      headingLvl={4}
                      item={item}
                      hideAddFavorites={true}
                      size="normal"
                      newspartners={false}
                      loading="lazy"
                      condensedBtns={false}
                      saveButtonBG={false}
                    />
                    <button
                      onClick={() => deleteTile(item)}
                      className="for-you-delete"
                    >
                      <IconClose
                        title="Remove this story"
                        color="var(--color-mpr-charcoal)"
                      />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                You currently have no favorite stories. Save some to view.
              </div>
            )}
          </div>
          <h3>Episodes</h3>
          <div className="collection">
            {favoriteEpisodes.length > 0 ? (
              <div>
                {favoriteEpisodes.map((item) => (
                  <div className="for-you-item" key={item.id}>
                    <Teaser
                      item={item}
                      hideAddFavorites={true}
                      size="normal"
                      newspartners={false}
                      loading="lazy"
                      condensedBtns={false}
                      saveButtonBG={false}
                    />
                    <button
                      onClick={() => deleteTile(item)}
                      className="for-you-delete"
                    >
                      <IconClose
                        title="Remove this story"
                        color="var(--color-mpr-charcoal)"
                      />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                You currently have no favorite episodes. Save some to view.
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );

  return <ForYouInner current="stories" inner={Jsx} />;
};

export const getServerSideProps = (async (context) => {
  const session = await getServerSession(context.req, context.res, authOptions);
  return {
    props: {
      session,
    },
  };
}) satisfies GetServerSideProps;

export default ForYou;
